import { EmailTemplate } from '../../../mocks/emails';

interface TemplateCardProps {
  template: EmailTemplate;
  onUse: (template: EmailTemplate) => void;
  onPreview: (template: EmailTemplate) => void;
}

export default function TemplateCard({ template, onUse, onPreview }: TemplateCardProps) {
  const formatDate = (d: string) =>
    new Date(d).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });

  return (
    <div className="bg-white rounded-xl border border-gray-100 hover:border-gray-200 transition-all duration-200 flex flex-col overflow-hidden group">
      {/* Header */}
      <div
        className="px-5 py-4 flex items-start gap-3"
        style={{ backgroundColor: template.bgColor }}
      >
        <div
          className="w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0"
          style={{ backgroundColor: template.color + '20', color: template.color }}
        >
          <i className={`${template.icon} text-xl`} />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="font-semibold text-gray-800 text-sm leading-snug">{template.name}</h3>
          <div className="flex items-center gap-1.5 mt-1 flex-wrap">
            {template.tags.map((tag) => (
              <span
                key={tag}
                className="text-xs px-1.5 py-0.5 rounded font-medium"
                style={{ backgroundColor: template.color + '18', color: template.color }}
              >
                {tag}
              </span>
            ))}
          </div>
        </div>
      </div>

      {/* Body */}
      <div className="px-5 py-3 flex-1">
        <p className="text-xs text-gray-500 leading-relaxed">{template.description}</p>
        <div className="mt-3 p-2.5 bg-gray-50 rounded-lg border border-dashed border-gray-200">
          <p className="text-xs text-gray-400 font-medium uppercase tracking-wide mb-0.5">Subject line</p>
          <p className="text-xs text-gray-600 truncate">{template.subject || 'Custom subject'}</p>
        </div>
      </div>

      {/* Footer */}
      <div className="px-5 py-3 border-t border-gray-100 flex items-center justify-between">
        <div className="flex items-center gap-3 text-xs text-gray-400">
          <span className="flex items-center gap-1">
            <i className="ri-send-plane-line" />
            {template.usageCount} sent
          </span>
          <span>Last: {formatDate(template.lastUsed)}</span>
        </div>
        <div className="flex items-center gap-1.5">
          <button
            onClick={() => onPreview(template)}
            className="text-xs px-2.5 py-1.5 rounded-lg border border-gray-200 text-gray-600 hover:bg-gray-50 transition-colors cursor-pointer whitespace-nowrap"
          >
            Preview
          </button>
          <button
            onClick={() => onUse(template)}
            className="text-xs px-2.5 py-1.5 rounded-lg text-white transition-colors cursor-pointer whitespace-nowrap font-medium"
            style={{ backgroundColor: template.color }}
          >
            Use Template
          </button>
        </div>
      </div>
    </div>
  );
}
